import React from "react";
import { Route, Switch, useRouteMatch, useLocation, useHistory, Redirect } from "react-router-dom";
import Header from "./Header";
import ChatBox from "./ChatBox";
import Request from "./Request";
import Store from "./Store";
import OrdersAdmin from "./OrdersAdmin";
import Admin from "./Admin";
import NewQuotation from "./newQuotation";
import AddProduct from "./AddProduct";
import OrderDetailModal from "./OrderDetailModal";
import EditProduct from "./EditProduct";
import Presupuesto from "./Presupuesto";
import EditQuotation from "./EditQuotation";
import SeguimientoKanban from "./SeguimientoKanban";
import OrdenesEntregadas from "./OrdenesEntregadas";
import CRMCuentas from "./CRMCuentas";
import CRMDetalleCuenta from "./CRMDetalleCuenta";
import CRMTareas from "./CRMTareas";
import Inicio from "./Inicio";
import NuevaOrdenCompra from "./NuevaOrdenCompra";
import SolicitudesAdmin from "./SolicitudesAdmin";
import ProspeccionEmbudo from "./ProspeccionEmbudo";
import ProspeccionDetalle from "./ProspeccionDetalle";
import ProspeccionMiSemana from "./ProspeccionMiSemana";
import ProspeccionDescartados from "./ProspeccionDescartados";
import ProspeccionImportarGrilla from "./ProspeccionImportarGrilla";
import Procesos from "./Procesos";
import CotizacionesRechazadas from "./CotizacionesRechazadas";
import Comisiones from "./Comisiones";

const Dashboard = () => {
    let { path } = useRouteMatch();
    const location = useLocation();
    const history = useHistory();
    const { reopenModal, orderId } = location.state || {};

    return (
        <div style={{ minHeight: "100vh", background: "#f4f4f6" }}>
            <Header />
            <div>
                <Switch>
                    <Route exact path={`${path}`}>
                        <Inicio />
                    </Route>
                    <Route path={`${path}/nueva-oc`}>
                        <NuevaOrdenCompra />
                    </Route>
                    <Route path={`${path}/comisiones`}>
                        <Comisiones />
                    </Route>
                    <Route path={`${path}/orders`}>
                        <Request />
                    </Route>
                    <Route path={`${path}/request`}>
                        <Store />
                    </Route>
                    <Route path={`${path}/cotizaciones/solicitudes`}>
                        <SolicitudesAdmin />
                    </Route>
                    <Route path={`${path}/cotizaciones/rechazadas`}>
                        <CotizacionesRechazadas />
                    </Route>
                    <Route path={`${path}/cotizaciones`}>
                        <OrdersAdmin />
                        {reopenModal && (
                            <OrderDetailModal
                                order={{ id: orderId }}
                                onClose={() => {
                                    history.replace({
                                        pathname: `${path}/cotizaciones`,
                                        state: { reopenModal: false },
                                    });
                                }}
                            />
                        )}
                    </Route>
                    <Route path={`${path}/editproduct`}>
                        <EditProduct />
                    </Route>
                    <Route path={`${path}/admin`}>
                        {(() => {
                            let esAdmin = false;
                            try { esAdmin = String(JSON.parse(localStorage.getItem("user") || "{}").tipo) === "1"; } catch {}
                            return esAdmin ? <Admin /> : <Redirect to={path} />;
                        })()}
                    </Route>
                    <Route path={`${path}/newquotation/:orderId?`}>
                        <NewQuotation />
                    </Route>
                    <Route path={`${path}/addproduct`}>
                        <AddProduct />
                    </Route>
                    <Route path={`${path}/presupuesto`}>
                        <Presupuesto />
                    </Route>
                    <Route path={`${path}/editquotation/:orderId`}>
                        <EditQuotation />
                    </Route>
                    <Route path={`${path}/seguimiento`}>
                        <SeguimientoKanban />
                    </Route>
                    <Route path={`${path}/entregadas`}>
                        <OrdenesEntregadas />
                    </Route>
                    <Route path={`${path}/crm/cuenta/:cuentaId`}>
                        <CRMDetalleCuenta />
                    </Route>
                    <Route path={`${path}/crm/tareas`}>
                        <CRMTareas />
                    </Route>
                    <Route path={`${path}/crm/prospeccion/detalle/:id`}>
                        <ProspeccionDetalle />
                    </Route>
                    <Route path={`${path}/crm/prospeccion/mi-semana`}>
                        <ProspeccionMiSemana />
                    </Route>
                    <Route path={`${path}/crm/prospeccion/descartados`}>
                        <ProspeccionDescartados />
                    </Route>
                    <Route path={`${path}/crm/prospeccion/importar`}>
                        <ProspeccionImportarGrilla />
                    </Route>
                    <Route path={`${path}/crm/prospeccion`}>
                        <ProspeccionEmbudo />
                    </Route>
                    <Route path={`${path}/crm`}>
                        <CRMCuentas />
                    </Route>
                    <Route path={`${path}/procesos`}>
                        <Procesos />
                    </Route>
                </Switch>
            </div>
            <ChatBox />
        </div>
    );
};

export default Dashboard;